import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const api = createApi({
	reducerPath: 'OAuthAPI',
	baseQuery: fetchBaseQuery({
		baseUrl: `${import.meta.env.VITE_APP_OAUTH_API_URL}`
	}),
	endpoints: builder => ({
		oAuthLogin: builder.mutation({
			query: data => ({
				url: '/o/token/',
				method: 'POST',
				headers: {
					'content-type': 'application/x-www-form-urlencoded'
				},
				body: data
			})
		}),
		oAuthRefresh: builder.mutation({
			query: data => ({
				url: '/o/token/',
				method: 'POST',
				headers: {
					'content-type': 'application/x-www-form-urlencoded'
				},
				body: data
			})
		}),
		oAuthLogout: builder.mutation({
			query: data => ({
				url: '/v1/account/logout/',
				method: 'POST',
				headers: data.headers,
				body: {}
			})
		})
	})
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useOAuthLoginMutation,
	useOAuthRefreshMutation,
	useOAuthLogoutMutation
} = api;
